import { render, staticRenderFns } from "./DataMonitoring.vue?vue&type=template&id=83a7aeb0&scoped=true"
import script from "./DataMonitoring.vue?vue&type=script&lang=js"
export * from "./DataMonitoring.vue?vue&type=script&lang=js"
import style0 from "./DataMonitoring.vue?vue&type=style&index=0&id=83a7aeb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a7aeb0",
  null
  
)

export default component.exports